import HttpApi from 'i18next-http-backend';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import restFactory from 'v2/utils/restFactory';
import appTranslations from './locales/en/translation.json';
import { buildTranslationsFromMappedEntities, titlecase } from './helpers';
import { capitalize } from 'lodash';
import { PostProcessKeys } from './post-process-keys';

export enum TranslationLanguages {
  en = 'en',
}

export enum TranslationNamespaces {
  App = 'app',
  MappedEntities = 'mappedEntities',
}

export type MappedEntity = {
  original_word: string;
  mapped_name: string;
  mapped_plural_name: string;
};

export async function fetchMappedEntities() {
  let mappedEntities;

  try {
    mappedEntities = await restFactory.get<MappedEntity[]>(
      '/dj/api/v1/mapped_entities/'
    );
  } finally {
    return mappedEntities;
  }
}

export const i18nInstance = i18next
  .use(initReactI18next)
  .use({
    type: 'postProcessor',
    name: PostProcessKeys.TitleCase,
    process: titlecase,
  })
  .use({
    type: 'postProcessor',
    name: PostProcessKeys.Capitalize,
    process: capitalize,
  });

/**
 * Initialize i18next with local translation files
 */
i18nInstance.init({
  ns: [TranslationNamespaces.App, TranslationNamespaces.MappedEntities],
  lng: TranslationLanguages.en,
  debug: process.env.NODE_ENV === 'development',
  partialBundledLanguages: true,
  resources: {
    en: {
      [TranslationNamespaces.App]: appTranslations,
    },
  },
});

/**
 * loads translations from backend
 */
export function loadBackendTranslations() {
  i18nInstance.use(HttpApi).init({
    backend: {
      loadPath: '{{lng}}|{{ns}}',
      request: async (
        _options: any,
        url: string,
        _payload: any,
        callback: any
      ) => {
        const [lng, ns] = url.split('|');
        let translationsForNameSpace = {};

        if (
          lng === TranslationLanguages.en &&
          ns === TranslationNamespaces.MappedEntities
        ) {
          const mappedEntities = await fetchMappedEntities();

          if (mappedEntities)
            translationsForNameSpace =
              buildTranslationsFromMappedEntities(mappedEntities);
        }

        callback(null, {
          data: translationsForNameSpace,
          status: 200,
        });
      },
    },
  });
}
